// extracted by mini-css-extract-plugin
module.exports = {"overlay":"product-ui-overlay_overlay__BZ_4Q"};